export default __webpack_public_path__ + "static/media/recommended.58f470bd.png";